module.exports = __webpack_public_path__ + "static/media/CultureApp.d1952843.png";